if (typeof window.stockmansteaks === "undefined") {
  window.stockmansteaks = {
    addItem: async (payload = {}) => {
      const cartNotification = document.querySelector("cart-notification");

      const variantId = payload.variantId;
      const quantity = payload.quantity;
      const properties = payload.properties || undefined;
      const ignoreAddonsModal = payload.ignoreAddonsModal || false;
      const refreshedSections = payload.refreshedSections || "cart-notification-product,cart-notification-button,cart-icon-bubble";

      let url = window.routes.cart_add_url;

      if (ignoreAddonsModal) {
        url += "?ignore-addons-modal=1";
      }

      // Ensure variantId and quantity are provided
      if (!variantId || !quantity) {
        console.error("Variant ID and quantity are required.");
        return;
      }

      // Prepare the data for the AJAX request
      const data = {
        id: variantId,
        quantity: quantity,
        properties: properties,
        sections: refreshedSections,
      };

      // Make the AJAX request to Shopify's cart add endpoint
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: variantId,
            cartData: response,
          });

          cartNotification.renderContents(response);

          window.stockmansteaks.replaceSections(response);
          window.stockmansteaks.toggleCartEmpty(response.item_count === 0);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });

      return response;
    },
    autoAddItemInProductPage: () => {
      const autoAddValue =
        window.stockmansteaks.getQueryParam("auto-add") || null;
      const variantId = document.querySelector("input[name=id]")?.value || null;

      if (autoAddValue && variantId) {
        window.stockmansteaks.addItem({
          variantId: variantId,
          quantity: 1,
          ignoreAddonsModal: 1,
        });
      }
    },
    toggleCartEmpty: (isEmpty) => {
      const cartFooter = document.getElementById("main-cart-footer");
      const cartItems = document.querySelector("cart-items");

      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", isEmpty);
      }

      if (cartItems) {
        cartItems.classList.toggle("is-empty", isEmpty);
      }
    },
    replaceSections: (response) => {
      if (!response || !response.sections) {
        return;
      }

      console.log({ response });

      const sectionsToRender = [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: ['.js-contents'],
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: ['.shopify-section'],
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: ['.shopify-section'],
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: ['.js-contents', '.cart__ctas', '.cart__ctas-addon'],
        }
      ];

      function getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector)?.innerHTML;
      }

      sectionsToRender.forEach((section) => {
        section.selector.forEach((selector => {
          if (!response.sections[section.id]) {
            return;
          }

          const elementToReplace = document.getElementById(section.id).querySelector(selector) || document.getElementById(section.id);
          const innerHTML = getSectionInnerHTML(response.sections[section.id], selector);
          elementToReplace.innerHTML = innerHTML;
        }));
      });

      if (response?.sections?.['main-cart-items']) {
        const SCRIPT_ID = 'modal-change-type-possibility';
        const oldScript = document.querySelector(`#${SCRIPT_ID}`);
        const changeTypePossibilityInnerHTML = getSectionInnerHTML(response.sections['main-cart-items'], `#${SCRIPT_ID}`);

        if (oldScript) {
          oldScript.remove();
        }

        const newScript = document.createElement("script");
        newScript.id = SCRIPT_ID;
        newScript.type = "text/javascript";
        newScript.text = changeTypePossibilityInnerHTML;
        document.body.appendChild(newScript);
      }
    },
    getQueryParam: (key) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(key);
    },
    init: () => {
      window.stockmansteaks.autoAddItemInProductPage();
    },
  };

  window.stockmansteaks.init();
}
